import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { AlignType } from 'common/types/styleTypes'
import React from 'react'
import { Alignment } from '../../ui-lib/alignment'
import { AlignType as AlignmentValueType } from '../../ui-lib/alignment/types'

const alignTypeToAlignmentValue = (
  align: AlignType | undefined,
): AlignmentValueType => {
  switch (align) {
    case 'left':
      return 'left'
    case 'center':
      return 'center'
    case 'right':
      return 'right'
    default:
      return 'left'
  }
}

const alignmentValueToAlignType = (align: AlignmentValueType): AlignType => {
  switch (align) {
    case 'left':
      return 'left'
    case 'center':
      return 'center'
    case 'right':
      return 'right'
    default:
      return 'left'
  }
}

export interface TextAlignControlProps {
  textAlign: AlignType | undefined
  mobileTextAlign?: AlignType | undefined
  update: (val: AlignType) => void
  mobileUpdate?: (val: AlignType) => void
  className?: string
}

export const TextAlignControl = ({
  textAlign,
  mobileTextAlign,
  update,
  mobileUpdate,
  className,
}: TextAlignControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultTextAlign = isMobile ? mobileTextAlign || textAlign : textAlign

  const onChange = (align: AlignmentValueType) => {
    const alignType = alignmentValueToAlignType(align)
    return isMobile ? mobileUpdate?.(alignType) : update(alignType)
  }

  return (
    <Alignment
      value={alignTypeToAlignmentValue(resultTextAlign)}
      update={onChange}
      hideJustifyOption
      className={className}
    />
  )
}
